import React, { useState, useEffect, useContext } from "react";
import { Box, Card, CardActions, CssBaseline, Grid, Typography, Button, IconButton } from '@mui/material';
import { plantCurveApi } from "../../../../../api/Api";
import EnergyChartPower from "../../../../../components/charts/energy_reporting/EnergyChartPower";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { useTheme } from "@emotion/react";
import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";

import { TotalBatteryPowerApi } from "../../../../../api/Api";

// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export default function TotalBatteryPower({ ID, TabTitle }) {
    const { PrimaryColor } = useContext(AppThemeContext);
    const { palette, spacing } = useTheme();
    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const now = new Date(); // Current date and time

    // Default start and end dates
    const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0); // 5:00 AM
    const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0); // 8:00 PM

    const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
    const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);



    const [chartLabels, setChartLabels] = useState([]);
    
    const [powerData, setPowerData] = useState([]);
    
    const [gradientFill, setGradientFill] = useState(null);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE"),
        WEB_KEY: "WEBXYZ321",
        DT1: startDate,
        DT2: endDate
       
    };

    // Fetch log data from the API
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await TotalBatteryPowerApi(credentials);

            if (res?.Get_BAT_PLANT && Array.isArray(res.Get_BAT_PLANT)) {
                const labels = res.Get_BAT_PLANT.map((item) => item.DATET);

               

                const powerDataset = [
                    {
                        label: "Total Battery Power",
                        data: res.Get_BAT_PLANT.map((item) => parseFloat(item.BATTERY_POWER) || 0),
                        borderColor: "red",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 1,
                        pointHoverRadius: 2,
                    },
                ];

                

                setChartLabels(labels);
                
                setPowerData(powerDataset);
                
                
            } else {
                // console.warn("Empty or Invalid API Response Data");
                setChartLabels([]);
                
                setPowerData([]);
                
            }
        } catch (err) {
            // console.error("API Error:", err);
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const createGradientShade = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, palette.primary.main);
        gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
        return gradient;
    };

    useEffect(() => {
        setGradientFill(createGradientShade());
    }, [palette.primary.main]);

    // Fetch data on component mount and set up 30-second interval
    useEffect(() => {
        fetchLogData(); // Fetch data initially

        // Set up interval for 30-second refresh
        const interval = setInterval(() => {
            fetchLogData();
        }, 30000); // 30 seconds

        // Clean up interval on component unmount
        return () => clearInterval(interval);
    }, [startDate, endDate, gradientFill]);

    const handleStartDateChange = (value) => {
        const formattedDate = formatDateTime(new Date(value));
        setStartDate(formattedDate);
    };

    const handleEndDateChange = (value) => {
        const formattedDate = formatDateTime(new Date(value));
        setEndDate(formattedDate);
    };

    return (

        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>

                <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
                    <Grid key="chart-grid" item xs={12}>
                        <Card>
                            <CardActions sx={{
                                display: "flex", // Enable flexbox
                                justifyContent: "flex-end", // Align items to the right
                                alignItems: "center", // Center items vertically
                                gap: "16px", // Add some spacing between the inputs
                            }}>
                                <label>
                                    From:&nbsp;
                                    <input
                                        type="datetime-local"
                                        value={startDate.replace(" ", "T")}
                                        onChange={(e) => handleStartDateChange(e.target.value)}
                                        style={{
                                            padding: "2px 2px",
                                            borderRadius: "14px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </label>
                                <label>
                                    To:&nbsp;
                                    <input
                                        type="datetime-local"
                                        value={endDate.replace(" ", "T")}
                                        onChange={(e) => handleEndDateChange(e.target.value)}
                                        style={{
                                            padding: "2px 2px",
                                            borderRadius: "14px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </label>

                            </CardActions>
                        </Card>
                    </Grid>


                </Grid>

                <Grid container spacing={spacing(2)} flexGrow={1} sx={{ mt: 2 }}>

                    <Grid key="chart-grid" item xs={12}>
                        <Card>
                            <CardActions>
                                <EnergyChartPower labels={chartLabels}
                                    data={powerData}
                                    title="Total Battery Power" />


                                {/* <InvverterFullSize title={""} onFullScreen={handleOpenMix} />
                                <CurrentCurveChart data={chartDataVoltage} name={"Voltage Curve"} />
                            <AppModal open={OpenMix} handleClose={handleCloseMix}>
                            <CurrentCurveChart data={chartDataVoltage} name={"Voltage Curve"} />
                            </AppModal> */}

                            </CardActions>
                        </Card>
                    </Grid>

                   

                </Grid>




            </Box>

        </>


    );
}
